export const updatePageState = (pageState) => {
	return {
		type: "UPDATE_PAGESTATE",
		pageState: pageState
	}
}
